/**
 * Fallback handler: silent-stream
 *
 * Fires when VAD detects speech but no transcripts arrive within 10s —
 * the stream is live but producing no usable output.
 * A retry action is provided to re-establish the pipeline.
 */

import type { FallbackBanner } from "@/voice/types";

export function makeSilentStreamBanner(onRetry: () => void): FallbackBanner {
  return {
    kind: "silent-stream",
    message:
      "Your mic is on but no speech is being detected. Try speaking louder or check your mic.",
    retryAction: onRetry,
    retryLabel: "Try again",
  };
}
